/**
 * @internal
 */
export const white = "#FFFFFF";
/**
 * @internal
 */
export const black = "#000000";
/**
 * @internal
 */
export const accentBaseColor = "#DA1A5F";
/**
 * @internal
 */
export const neutralBaseColor = "#808080";
